module.exports = __webpack_public_path__ + "img/location.5cb1d0f3.jpg";